export default {_name:'acl.group.tabs',module:'Field',view:'Element/Acl/Group/Tabs',options:{events:{acl:'acl'},xs:12}}